import React from "react";
import SSOContainer from "../shared/containers/SSOContainer";
import MFASSOContainer from "../shared/containers/MFASSOContainer";
import Button from "../shared/buttons/Button";
import { getContentByVariationType } from "../../content/ContentDoneSimply";
import DocumentPreferenceContent, {
  contentTypesAvailable
} from "../../content/preferences/DocumentPreference";
import styles from "../../assets/css/modules/preference/document-preference.css";
import { Paths } from "../../constants/UrlConstants";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setIsUserOnboarding } from "../onboarding/onboardingActions";
import { Layouts } from "../../constants/Constants";
import { getCurrentLoggedInMemberFromPolicy } from "../../helpers/MemberHelper";
import mfaStyles from "../../assets/css/modules/containers/MFASSOContainer.css";

const isStandardHolPolicy = (loggedInMember, selectedPolicy) => {
  return loggedInMember.IsPolicyHolder && selectedPolicy.IsIndividual;
};

const isStandardMolPolicy = (loggedInMember, selectedPolicy) => {
  return (
    loggedInMember.IsPolicyHolder &&
    selectedPolicy.IsIndividual &&
    !selectedPolicy.IsInternational &&
    !selectedPolicy.IsSaga
  );
};

export const DocumentPreference = ({
  contentVariationType,
  history,
  setIsUserOnboarding
}) => {
  let content = getContentByVariationType(
    contentVariationType,
    DocumentPreferenceContent
  );

  return (
    window?.axa?.features?.MFAFeature === "true"?
      <MFASSOContainer mfaDocument={true}>
        <div className={styles.documentPreference}>
            <h1 className={`axa-headline ${styles.titleMFA}`}>{content.title}</h1>
            {content.body.paragraph1}
            {content.body.paragraph2}
            <button
                label={content.button}
                className={mfaStyles.buttonStart}
                onClick={() => {
                    setIsUserOnboarding(false);
                    history.push(Paths.HomeRoot);
                }}
                        type="submit"
                        >{content.button}</button>
          </div>
      </MFASSOContainer>:
    <SSOContainer>
      <div className={styles.documentPreference}>
        <h1 className={`axa-headline ${styles.title}`}>{content.title}</h1>
        {content.body.paragraph1}
        {content.body.paragraph2}
        <Button
          label={content.button}
          onClick={() => {
            setIsUserOnboarding(false);
            history.push(Paths.HomeRoot);
          }}
        ></Button>
      </div>
    </SSOContainer>
  );
};

export const mapStateToDocumentPreferences = ({
  layoutReducer,
  policyReducer
} = {}) => {
  let selectedPolicy = policyReducer && policyReducer.selectedPolicy;
  let layout = layoutReducer && layoutReducer.layout;
  let loggedInMember = getCurrentLoggedInMemberFromPolicy(selectedPolicy);

  let contentVariationType = "unknown";

  if (selectedPolicy && loggedInMember) {
    if (layout === Layouts.HOL) {
      if (isStandardHolPolicy(loggedInMember, selectedPolicy)) {
        contentVariationType = contentTypesAvailable.Hol;
      } else {
        contentVariationType = contentTypesAvailable.HolAlternate;
      }
    } else {
      if (isStandardMolPolicy(loggedInMember, selectedPolicy)) {
        contentVariationType = contentTypesAvailable.Mol;
      } else {
        contentVariationType = contentTypesAvailable.MolAlternate;
      }
    }
  }

  return {
    contentVariationType
  };
};

export default withRouter(
  connect(mapStateToDocumentPreferences, { setIsUserOnboarding })(
    DocumentPreference
  )
);
